import { useCallback } from 'react';
import { configApi } from 'scenes/common/api';

export const useConfigActions = (
  onApiResponse: <T extends Partial<T>>(data: T) => void
) => {
  const handleConfigResponse = useCallback(
    (configResponse) => {
      onApiResponse({ config: configResponse });
    },
    [onApiResponse]
  );

  const onGetConfig = useCallback(() => {
    configApi()
      .getConfig()
      .then((configResponse) => {
        handleConfigResponse(configResponse);
      });
  }, [handleConfigResponse]);

  return {
    onGetConfig,
  };
};
